/**
 * PdfBrushes.ts class for EJ2-PDF
 */
import { PdfColor } from './../pdf-color';
import { Dictionary } from './../../collections/dictionary';
import { KnownColor } from './enum';
import { PdfSolidBrush } from './pdf-solid-brush';
/**
 * `PdfBrushes` class provides objects used to fill the interiors of graphical shapes such as rectangles,
 * ellipses, pies, polygons, and paths.
 * @private
 */
var PdfBrushes = /** @class */ (function () {
    function PdfBrushes() {
    }
    Object.defineProperty(PdfBrushes, "AliceBlue", {
        /**
         * Gets the AliceBlue brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.AliceBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "AntiqueWhite", {
        /**
         * Gets the antique white brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.AntiqueWhite); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Aqua", {
        /**
         * Gets the Aqua default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Aqua); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Aquamarine", {
        /**
         * Gets the Aquamarine default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Aquamarine); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Azure", {
        /**
         * Gets the Azure default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Azure); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Beige", {
        /**
         * Gets the Beige default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Beige); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Bisque", {
        /**
         * Gets the Bisque default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Bisque); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Black", {
        /**
         * Gets the Black default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Black); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "BlanchedAlmond", {
        /**
         * Gets the BlanchedAlmond default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.BlanchedAlmond); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Blue", {
        /**
         * Gets the Blue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Blue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "BlueViolet", {
        /**
         * Gets the BlueViolet default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.BlueViolet); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Brown", {
        /**
         * Gets the Brown default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Brown); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "BurlyWood", {
        /**
         * Gets the BurlyWood default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.BurlyWood); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "CadetBlue", {
        /**
         * Gets the CadetBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.CadetBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Chartreuse", {
        /**
         * Gets the Chartreuse default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Chartreuse); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Chocolate", {
        /**
         * Gets the Chocolate default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Chocolate); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Coral", {
        /**
         * Gets the Coral default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Coral); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "CornflowerBlue", {
        /**
         * Gets the CornflowerBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.CornflowerBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Cornsilk", {
        /**
         * Gets the Cornsilk default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Cornsilk); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Crimson", {
        /**
         * Gets the Crimson default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Crimson); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Cyan", {
        /**
         * Gets the Cyan default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Cyan); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkBlue", {
        /**
         * Gets the DarkBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkCyan", {
        /**
         * Gets the DarkCyan default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkCyan); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkGoldenrod", {
        /**
         * Gets the DarkGoldenrod default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkGoldenrod); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkGray", {
        /**
         * Gets the DarkGray default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkGray); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkGreen", {
        /**
         * Gets the DarkGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkKhaki", {
        /**
         * Gets the DarkKhaki default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkKhaki); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkMagenta", {
        /**
         * Gets the DarkMagenta default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkMagenta); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkOliveGreen", {
        /**
         * Gets the DarkOliveGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkOliveGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkOrange", {
        /**
         * Gets the DarkOrange default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkOrange); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkOrchid", {
        /**
         * Gets the DarkOrchid default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkOrchid); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkRed", {
        /**
         * Gets the DarkRed default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkRed); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkSalmon", {
        /**
         * Gets the DarkSalmon default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkSalmon); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkSeaGreen", {
        /**
         * Gets the DarkSeaGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkSeaGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkSlateBlue", {
        /**
         * Gets the DarkSlateBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkSlateBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkSlateGray", {
        /**
         * Gets the DarkSlateGray default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkSlateGray); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkTurquoise", {
        /**
         * Gets the DarkTurquoise default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkTurquoise); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DarkViolet", {
        /**
         * Gets the DarkViolet default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DarkViolet); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DeepPink", {
        /**
         * Gets the DeepPink default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DeepPink); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DeepSkyBlue", {
        /**
         * Gets the DeepSkyBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DeepSkyBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DimGray", {
        /**
         * Gets the DimGray default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DimGray); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "DodgerBlue", {
        /**
         * Gets the DodgerBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.DodgerBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Firebrick", {
        /**
         * Gets the Firebrick default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Firebrick); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "FloralWhite", {
        /**
         * Gets the FloralWhite default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.FloralWhite); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "ForestGreen", {
        /**
         * Gets the ForestGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.ForestGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Fuchsia", {
        /**
         * Gets the Fuchsia default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Fuchsia); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Gainsboro", {
        /**
         * Gets the Gainsboro default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Gainsboro); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "GhostWhite", {
        /**
         * Gets the GhostWhite default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.GhostWhite); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Gold", {
        /**
         * Gets the Gold default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Gold); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Goldenrod", {
        /**
         * Gets the Goldenrod default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Goldenrod); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Gray", {
        /**
         * Gets the Gray default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Gray); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Green", {
        /**
         * Gets the Green default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Green); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "GreenYellow", {
        /**
         * Gets the GreenYellow default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.GreenYellow); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Honeydew", {
        /**
         * Gets the Honeydew default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Honeydew); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "HotPink", {
        /**
         * Gets the HotPink default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.HotPink); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "IndianRed", {
        /**
         * Gets the IndianRed default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.IndianRed); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Indigo", {
        /**
         * Gets the Indigo default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Indigo); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Ivory", {
        /**
         * Gets the Ivory default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Ivory); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Khaki", {
        /**
         * Gets the Khaki default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Khaki); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Lavender", {
        /**
         * Gets the Lavender default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Lavender); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LavenderBlush", {
        /**
         * Gets the LavenderBlush default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LavenderBlush); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LawnGreen", {
        /**
         * Gets the LawnGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LawnGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LemonChiffon", {
        /**
         * Gets the LemonChiffon default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LemonChiffon); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightBlue", {
        /**
         * Gets the LightBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightCoral", {
        /**
         * Gets the LightCoral default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightCoral); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightCyan", {
        /**
         * Gets the LightCyan default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightCyan); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightGoldenrodYellow", {
        /**
         * Gets the LightGoldenrodYellow default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightGoldenrodYellow); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightGray", {
        /**
         * Gets the LightGray default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightGray); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightGreen", {
        /**
         * Gets the LightGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightPink", {
        /**
         * Gets the LightPink default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightPink); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightSalmon", {
        /**
         * Gets the LightSalmon default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightSalmon); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightSeaGreen", {
        /**
         * Gets the LightSeaGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightSeaGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightSkyBlue", {
        /**
         * Gets the LightSkyBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightSkyBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightSlateGray", {
        /**
         * Gets the LightSlateGray default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightSlateGray); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightSteelBlue", {
        /**
         * Gets the LightSteelBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightSteelBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LightYellow", {
        /**
         * Gets the LightYellow default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LightYellow); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Lime", {
        /**
         * Gets the Lime default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Lime); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "LimeGreen", {
        /**
         * Gets the LimeGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.LimeGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Linen", {
        /**
         * Gets the Linen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Linen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Magenta", {
        /**
         * Gets the Magenta default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Magenta); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Maroon", {
        /**
         * Gets the Maroon default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Maroon); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MediumAquamarine", {
        /**
         * Gets the MediumAquamarine default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MediumAquamarine); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MediumBlue", {
        /**
         * Gets the MediumBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MediumBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MediumOrchid", {
        /**
         * Gets the MediumOrchid default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MediumOrchid); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MediumPurple", {
        /**
         * Gets the MediumPurple default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MediumPurple); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MediumSeaGreen", {
        /**
         * Gets the MediumSeaGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MediumSeaGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MediumSlateBlue", {
        /**
         * Gets the MediumSlateBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MediumSlateBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MediumSpringGreen", {
        /**
         * Gets the MediumSpringGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MediumSpringGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MediumTurquoise", {
        /**
         * Gets the MediumTurquoise default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MediumTurquoise); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MediumVioletRed", {
        /**
         * Gets the MediumVioletRed default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MediumVioletRed); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MidnightBlue", {
        /**
         * Gets the MidnightBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MidnightBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MintCream", {
        /**
         * Gets the MintCream default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MintCream); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "MistyRose", {
        /**
         * Gets the MistyRose default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.MistyRose); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Moccasin", {
        /**
         * Gets the Moccasin default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Moccasin); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "NavajoWhite", {
        /**
         * Gets the NavajoWhite default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.NavajoWhite); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Navy", {
        /**
         * Gets the Navy default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Navy); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "OldLace", {
        /**
         * Gets the OldLace default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.OldLace); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Olive", {
        /**
         * Gets the Olive default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Olive); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "OliveDrab", {
        /**
         * Gets the OliveDrab default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.OliveDrab); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Orange", {
        /**
         * Gets the Orange default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Orange); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "OrangeRed", {
        /**
         * Gets the OrangeRed default brush.
         * @public
        */
        get: function () { return this.getBrush(KnownColor.OrangeRed); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Orchid", {
        /**
         * Gets the Orchid default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Orchid); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "PaleGoldenrod", {
        /**
         * Gets the PaleGoldenrod default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.PaleGoldenrod); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "PaleGreen", {
        /**
         * Gets the PaleGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.PaleGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "PaleTurquoise", {
        /**
         * Gets the PaleTurquoise default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.PaleTurquoise); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "PaleVioletRed", {
        /**
         * Gets the PaleVioletRed default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.PaleVioletRed); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "PapayaWhip", {
        /**
         * Gets the PapayaWhip default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.PapayaWhip); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "PeachPuff", {
        /**
         * Gets the PeachPuff default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.PeachPuff); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Peru", {
        /**
         * Gets the Peru default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Peru); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Pink", {
        /**
         * Gets the Pink default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Pink); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Plum", {
        /**
         * Gets the Plum default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Plum); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "PowderBlue", {
        /**
         * Gets the PowderBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.PowderBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Purple", {
        /**
         * Gets the Purple default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Purple); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Red", {
        /**
         * Gets the Red default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Red); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "RosyBrown", {
        /**
         * Gets the RosyBrown default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.RosyBrown); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "RoyalBlue", {
        /**
         * Gets the RoyalBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.RoyalBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "SaddleBrown", {
        /**
         * Gets the SaddleBrown default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.SaddleBrown); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Salmon", {
        /**
         * Gets the Salmon default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Salmon); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "SandyBrown", {
        /**
         * Gets the SandyBrown default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.SandyBrown); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "SeaGreen", {
        /**
         * Gets the SeaGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.SeaGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "SeaShell", {
        /**
         * Gets the SeaShell default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.SeaShell); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Sienna", {
        /**
         * Gets the Sienna default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Sienna); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Silver", {
        /**
         * Gets the Silver default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Silver); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "SkyBlue", {
        /**
         * Gets the SkyBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.SkyBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "SlateBlue", {
        /**
         * Gets the SlateBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.SlateBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "SlateGray", {
        /**
         * Gets the SlateGray default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.SlateGray); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Snow", {
        /**
         * Gets the Snow default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Snow); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "SpringGreen", {
        /**
         * Gets the SpringGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.SpringGreen); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "SteelBlue", {
        /**
         * Gets the SteelBlue default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.SteelBlue); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Tan", {
        /**
         * Gets the Tan default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Tan); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Teal", {
        /**
         * Gets the Teal default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Teal); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Thistle", {
        /**
         * Gets the Thistle default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Thistle); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Tomato", {
        /**
         * Gets the Tomato default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Tomato); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Transparent", {
        /**
         * Gets the Transparent default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Transparent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Turquoise", {
        /**
         * Gets the Turquoise default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Turquoise); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Violet", {
        /**
         * Gets the Violet default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Violet); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Wheat", {
        /**
         * Gets the Wheat default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Wheat); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "White", {
        /**
         * Gets the White default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.White); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "WhiteSmoke", {
        /**
         * Gets the WhiteSmoke default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.WhiteSmoke); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "Yellow", {
        /**
         * Gets the Yellow default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.Yellow); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PdfBrushes, "YellowGreen", {
        /**
         * Gets the YellowGreen default brush.
         * @public
         */
        get: function () { return this.getBrush(KnownColor.YellowGreen); },
        enumerable: true,
        configurable: true
    });
    /**
     * Get the brush.
     */
    PdfBrushes.getBrush = function (colorName) {
        var brush = (this.sBrushes.getValue(colorName));
        if (brush == null) {
            var pdfColor = this.getColorValue(colorName);
            brush = new PdfSolidBrush(pdfColor);
            this.sBrushes.setValue(colorName, brush);
        }
        return brush;
    };
    /**
     * Get the color value.
     * @param colorName The KnownColor name.
     */
    /* tslint:disable-next-line: max-line-length */
    PdfBrushes.getColorValue = function (colorName) {
        var color = new PdfColor();
        if (colorName >= KnownColor.Transparent && colorName <= KnownColor.MenuHighlight) {
            var index = (colorName - KnownColor.Transparent) * 4;
            var alpha = this.knownColorData.charCodeAt(index + 3) === 0 ? 0 : 255;
            color = new PdfColor(alpha, this.knownColorData.charCodeAt(index), this.knownColorData.charCodeAt(index + 1), this.knownColorData.charCodeAt(index + 2));
        }
        return color;
    };
    //Static Fields
    /**
     * Local variable to store the brushes.
     */
    PdfBrushes.sBrushes = new Dictionary();
    /**
     * Packed known color data (in KnownColor enum order, starting at Transparent).
     * Each color occupies two chars: the first holds the RGB value, the second the alpha flag
     * (0 - transparent, 1 - opaque).
     */
    /* tslint:disable-next-line:max-line-length */
    PdfBrushes.knownColorData = '\u00ff\u00ff\u00ff\u0000\u00f0\u00f8\u00ff\u0001\u00fa\u00eb\u00d7\u0001\u0000\u00ff\u00ff\u0001\u007f\u00ff\u00d4\u0001\u00f0\u00ff\u00ff\u0001\u00f5\u00f5\u00dc\u0001\u00ff\u00e4\u00c4\u0001\u0000\u0000\u0000\u0001\u00ff\u00eb\u00cd\u0001\u0000\u0000\u00ff\u0001\u008a\u002b\u00e2\u0001\u00a5\u002a\u002a\u0001\u00de\u00b8\u0087\u0001\u005f\u009e\u00a0\u0001\u007f\u00ff\u0000\u0001\u00d2\u0069\u001e\u0001\u00ff\u007f\u0050\u0001\u0064\u0095\u00ed\u0001\u00ff\u00f8\u00dc\u0001\u00dc\u0014\u003c\u0001\u0000\u00ff\u00ff\u0001\u0000\u0000\u008b\u0001\u0000\u008b\u008b\u0001\u00b8\u0086\u000b\u0001\u00a9\u00a9\u00a9\u0001\u0000\u0064\u0000\u0001\u00bd\u00b7\u006b\u0001\u008b\u0000\u008b\u0001\u0055\u006b\u002f\u0001\u00ff\u008c\u0000\u0001\u0099\u0032\u00cc\u0001\u008b\u0000\u0000\u0001\u00e9\u0096\u007a\u0001\u008f\u00bc\u008b\u0001\u0048\u003d\u008b\u0001\u002f\u004f\u004f\u0001\u0000\u00ce\u00d1\u0001\u0094\u0000\u00d3\u0001\u00ff\u0014\u0093\u0001\u0000\u00bf\u00ff\u0001\u0069\u0069\u0069\u0001\u001e\u0090\u00ff\u0001\u00b2\u0022\u0022\u0001\u00ff\u00fa\u00f0\u0001\u0022\u008b\u0022\u0001\u00ff\u0000\u00ff\u0001\u00dc\u00dc\u00dc\u0001\u00f8\u00f8\u00ff\u0001\u00ff\u00d7\u0000\u0001\u00da\u00a5\u0020\u0001\u0080\u0080\u0080\u0001\u0000\u0080\u0000\u0001\u00ad\u00ff\u002f\u0001\u00f0\u00ff\u00f0\u0001\u00ff\u0069\u00b4\u0001\u00cd\u005c\u005c\u0001\u004b\u0000\u0082\u0001\u00ff\u00ff\u00f0\u0001\u00f0\u00e6\u008c\u0001\u00e6\u00e6\u00fa\u0001\u00ff\u00f0\u00f5\u0001\u007c\u00fc\u0000\u0001\u00ff\u00fa\u00cd\u0001\u00ad\u00d8\u00e6\u0001\u00f0\u0080\u0080\u0001\u00e0\u00ff\u00ff\u0001\u00fa\u00fa\u00d2\u0001\u00d3\u00d3\u00d3\u0001\u0090\u00ee\u0090\u0001\u00ff\u00b6\u00c1\u0001\u00ff\u00a0\u007a\u0001\u0020\u00b2\u00aa\u0001\u0087\u00ce\u00fa\u0001\u0077\u0088\u0099\u0001\u00b0\u00c4\u00de\u0001\u00ff\u00ff\u00e0\u0001\u0000\u00ff\u0000\u0001\u0032\u00cd\u0032\u0001\u00fa\u00f0\u00e6\u0001\u00ff\u0000\u00ff\u0001\u0080\u0000\u0000\u0001\u0066\u00cd\u00aa\u0001\u0000\u0000\u00cd\u0001\u00ba\u0055\u00d3\u0001\u0093\u0070\u00db\u0001\u003c\u00b3\u0071\u0001\u007b\u0068\u00ee\u0001\u0000\u00fa\u009a\u0001\u0048\u00d1\u00cc\u0001\u00c7\u0015\u0085\u0001\u0019\u0019\u0070\u0001\u00f5\u00ff\u00fa\u0001\u00ff\u00e4\u00e1\u0001\u00ff\u00e4\u00b5\u0001\u00ff\u00de\u00ad\u0001\u0000\u0000\u0080\u0001\u00fd\u00f5\u00e6\u0001\u0080\u0080\u0000\u0001\u006b\u008e\u0023\u0001\u00ff\u00a5\u0000\u0001\u00ff\u0045\u0000\u0001\u00da\u0070\u00d6\u0001\u00ee\u00e8\u00aa\u0001\u0098\u00fb\u0098\u0001\u00af\u00ee\u00ee\u0001\u00db\u0070\u0093\u0001\u00ff\u00ef\u00d5\u0001\u00ff\u00da\u00b9\u0001\u00cd\u0085\u003f\u0001\u00ff\u00c0\u00cb\u0001\u00dd\u00a0\u00dd\u0001\u00b0\u00e0\u00e6\u0001\u0080\u0000\u0080\u0001\u00ff\u0000\u0000\u0001\u00bc\u008f\u008f\u0001\u0041\u0069\u00e1\u0001\u008b\u0045\u0013\u0001\u00fa\u0080\u0072\u0001\u00f4\u00a4\u0060\u0001\u002e\u008b\u0057\u0001\u00ff\u00f5\u00ee\u0001\u00a0\u0052\u002d\u0001\u00c0\u00c0\u00c0\u0001\u0087\u00ce\u00eb\u0001\u006a\u005a\u00cd\u0001\u0070\u0080\u0090\u0001\u00ff\u00fa\u00fa\u0001\u0000\u00ff\u007f\u0001\u0046\u0082\u00b4\u0001\u00d2\u00b4\u008c\u0001\u0000\u0080\u0080\u0001\u00d8\u00bf\u00d8\u0001\u00ff\u0063\u0047\u0001\u0040\u00e0\u00d0\u0001\u00ee\u0082\u00ee\u0001\u00f5\u00de\u00b3\u0001\u00ff\u00ff\u00ff\u0001\u00f5\u00f5\u00f5\u0001\u00ff\u00ff\u0000\u0001\u009a\u00cd\u0032\u0001\u0000\u0000\u0000\u0001\u0000\u0000\u0000\u0001\u0000\u0000\u0000\u0001\u0000\u0000\u0000\u0001\u0000\u0000\u0000\u0001\u0000\u0000\u0000\u0001\u0000\u0000\u0000\u0001';
    return PdfBrushes;
}());
export { PdfBrushes };
